import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

document.addEventListener('DOMContentLoaded', () => {
    const gallery = document.querySelector('.pdw-gallery-masonry');

    if (gallery) {
        imagesLoaded(gallery, () => {
      //      console.log('Toutes les images sont chargées ✅');

            new Masonry(gallery, {
                itemSelector: '.masonry-item',
                percentPosition: true,
                horizontalOrder: true,
                fitWidth: false,
     //        gutter: 0,
            });
        });
    }
});